"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Thumbnail = _interopRequireDefault(require("./_Thumbnail"));
// eslint-disable-next-line max-len
var greythumbnail = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODhweCIgaGVpZ2h0PSI4OHB4IiB2aWV3Qm94PSIwIDAgODggODgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+UmVjdGFuZ2xlIENvcHkgMjwvdGl0bGU+CiAgICA8ZyBpZD0iRGVza3RvcCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkRlc2t0b3AtSEQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zOS4wMDAwMDAsIC0zNDUuMDAwMDAwKSIgZmlsbD0iI0UwREZFMSI+CiAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtQ29weS0yIiB4PSIzOSIgeT0iMzQ1IiB3aWR0aD0iODgiIGhlaWdodD0iODgiPjwvcmVjdD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==';
var ThumbnailSkeleton = function ThumbnailSkeleton() {
  return /*#__PURE__*/_react["default"].createElement(_Thumbnail["default"], {
    src: greythumbnail,
    mediaType: "skeleton",
    caption: "",
    selected: false,
    remaining: -1,
    showSkeleton: true
  });
};
var ThumbnailSkeletons = function ThumbnailSkeletons() {
  return [/*#__PURE__*/_react["default"].createElement(ThumbnailSkeleton, {
    key: "thumbnail-skeleton-one"
  }), /*#__PURE__*/_react["default"].createElement(ThumbnailSkeleton, {
    key: "thumbnail-skeleton-two"
  }), /*#__PURE__*/_react["default"].createElement(ThumbnailSkeleton, {
    key: "thumbnail-skeleton-three"
  }), /*#__PURE__*/_react["default"].createElement(ThumbnailSkeleton, {
    key: "thumbnail-skeleton-four"
  }), /*#__PURE__*/_react["default"].createElement(ThumbnailSkeleton, {
    key: "thumbnail-skeleton-five"
  }), /*#__PURE__*/_react["default"].createElement(ThumbnailSkeleton, {
    key: "thumbnail-skeleton-six"
  })];
};
var _default = ThumbnailSkeletons;
exports["default"] = _default;
//# sourceMappingURL=ThumbnailSkeletons.js.map